import { BarcodeScanner } from 'dynamsoft-barcode-reader-bundle';

export function createBarcodeScanner() {
  return new BarcodeScanner({
    license:
      'f0068MgAAABxuENoC1AXay9FLb52+Q0iFiHDqdHFyhFHp8IPiszjrowF+rHsEScfAcILlufMGngW+cOr0kpv0UlzE49ADggU=',
    container: '#scannerContainer',
    uiPath:
      '/dist-pmaktif-web/dynamsoft-barcode-reader-bundle@11.2.2000/dist/ui/barcode-scanner.ui.xml',
    engineResourcePaths: {
      rootDirectory: '/dist-pmaktif-web/',
    },
    scannerViewConfig: {
      showCloseButton: false,
    },
    onInitReady: components => {
      components.cameraView.setScanLaserVisible(true);
      components.cameraView.setVideoFit('contain');
    },
    showPoweredByDynamsoft: false,
  });
}
